export const BUILDIN = "@dataSelection/BUILDIN";
export const UPLOAD = "@dataSelection/UPLOAD";
export const SUBMIT_GEOJSON = "@dataSelection/SUBMIT_GEOJSON";
export const DRAW = "@dataSelection/DRAW";
export const SELECTED_DATA = "@dataSelection/SELECTED_DATA";
export const SET_SUBMIT_CLICKED = "@dataSelection/SET_SUBMIT_CLICKED";

export const UPDATE_BASEMAP = "@dataLayers/UPDATE_BASEMAP";

export const ADD_ITEMS = "@returnItems/ADD_ITEMS";
export const CLEAR_ITEMS = "@returnItems/CLEAR_ITEMS";
export const SET_SUBMIT_STATUS = "@returnItems/SET_SUBMIT_STATUS";
export const SET_CHART = "@returnChart/SET_CHART";
export const RETURN_COLLECTION = "@returnCollection/RETURN_COLLECTION";
export const RETURN_DATA_COLLECTIONS = "@returnCollections/RETURN_DATA_COLLECTIONS";
export const ANALYSIS_COLLECTIONS = "@returnCollections/ANALYSIS_COLLECTIONS";

export const SELECT_MODEL = "@newJob/SELECT_MODEL";

export const SET_TILES = "@computingView/SET_TILES";
export const SET_GRIDS = "@computingView/SET_GRIDS";
